import React from 'react';
import headshot from '../assets/updated_headshot.png';

const GITHUB_URL = 'https://github.com/Mister905';
const LINKEDIN_URL = 'https://www.linkedin.com/in/james-mccarthy-159230199/';

interface HeroProps {}

const Hero: React.FC<HeroProps> = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      aria-label="Introduction"
      className="relative min-h-screen flex items-center justify-center bg-heraldic-charcoal px-4 sm:px-6 lg:px-8 py-24"
    >
      <div className="max-w-5xl mx-auto flex flex-col items-center">
        {/* <img
          src={heraldry}
          alt=""
          className="w-16 h-16 sm:w-20 sm:h-20 mb-8 object-contain opacity-90"
          width={80}
          height={80}
          aria-hidden="true"
        /> */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 w-full">
          <div className="shrink-0">
            <img
              src={headshot}
              alt="James McCarthy"
              className="w-44 h-44 sm:w-52 sm:h-52 rounded-full object-cover border border-heraldic-gold/40"
              width={208}
              height={208}
            />
          </div>
          <div className="text-center lg:text-left">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight text-white mb-3">
              James McCarthy
            </h1>
            <p className="text-sm sm:text-base text-accent tracking-[0.2em] uppercase font-medium mb-6">
              Full-Stack Software Engineer
            </p>
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0">
              I build reliable, accessible web applications and APIs across enterprise
              banking, government SaaS, and network operations.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <button
                type="button"
                onClick={() => scrollToSection('projects')}
                className="w-full sm:w-auto px-8 py-3 bg-accent text-heraldic-charcoal font-semibold rounded-sm hover:bg-accent-light focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-heraldic-charcoal transition-colors"
              >
                View Work
              </button>
              <a
                href="/resume_2026.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-8 py-3 border border-gray-500 text-gray-200 font-semibold rounded-sm hover:border-accent hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-heraldic-charcoal transition-colors text-center"
              >
                Resume
              </a>
            </div>
            <div className="mt-8 flex items-center justify-center lg:justify-start gap-6 text-sm tracking-wide">
              <a
                href={GITHUB_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-heraldic-charcoal rounded-sm transition-colors"
              >
                GitHub
              </a>
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-heraldic-charcoal rounded-sm transition-colors"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
